import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=ccf930e2&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=js&"
export * from "./Forgot.vue?vue&type=script&lang=js&"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=ccf930e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf930e2",
  null
  
)

export default component.exports